/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { RouteInterface } from '../types/routes';

export const termsOfUserRoute: RouteInterface = {
  id: 'legal_terms',
  label: 'Terms of Use',
  path: '/legal-terms/',
};

export const privacyPolicyRoute: RouteInterface = {
  id: 'privacy_policy',
  label: 'Privacy Policy',
  path: '/legal-privacy-policy/',
};

export const footerRoutes = [
  termsOfUserRoute,
  privacyPolicyRoute
]
